import { Redirect } from "expo-router";

export default function AccountIndexWeb() {
    return <Redirect href="/" />;
} 